export default __webpack_public_path__ + "static/media/PeacockPage1.a9fde907.txt";